import { render, staticRenderFns } from "./ListSkillPage.vue?vue&type=template&id=b557f0c8&"
import script from "./ListSkillPage.vue?vue&type=script&lang=js&"
export * from "./ListSkillPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports